import { FC, Fragment, useCallback, useState } from "react";
import { ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { ResourceExplorerV2ViewDeleteDialog } from "./ResourceExplorerV2ViewDeleteDialog";
import { ResourceExplorerV2ViewRenameDialog } from "./ResourceExplorerV2ViewRenameDialog";
import { ResourceExplorerV2ViewMoveAction } from "./move-action/ResourceExplorerV2ViewMoveAction";
import { navigationHierarchyItemNoDndKey } from "../../../sortable-tree/utils/constants";

interface ResourceExplorerV2ViewListItemActionsMenuProps {
  id: string;
  name: string;
  open: boolean;
  closeMenu(): void;
  anchor: HTMLElement | null;
  folderId?: string;
}

export const ResourceExplorerV2ViewListItemActionsMenu: FC<
  ResourceExplorerV2ViewListItemActionsMenuProps
> = ({ name, id, open, anchor, closeMenu, folderId }) => {
  const [selectedActionType, setSelectedActionType] = useState<
    "delete" | "rename" | "move" | null
  >();

  const deleteClickHandler = useCallback(() => {
    setSelectedActionType("delete");
  }, []);

  const renameClickHandler = useCallback(() => {
    setSelectedActionType("rename");
  }, []);

  const closeDialog = useCallback(() => {
    closeMenu();
    setSelectedActionType(null);
  }, [closeMenu]);

  return (
    <Fragment>
      <Menu
        open={open}
        onClose={closeMenu}
        anchorEl={anchor}
        {...navigationHierarchyItemNoDndKey}
      >
        <MenuItem onClick={renameClickHandler} sx={menuItemSx}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="small" sx={iconSx} />
          </ListItemIcon>
          <Typography variant="body2">Rename</Typography>
        </MenuItem>

        <ResourceExplorerV2ViewMoveAction
          id={id}
          folderId={folderId}
          onClose={closeMenu}
        />

        <MenuItem onClick={deleteClickHandler} sx={menuItemSx}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" sx={iconSx} />
          </ListItemIcon>
          <Typography variant="body2">Delete</Typography>
        </MenuItem>
      </Menu>

      {selectedActionType === "delete" && (
        <ResourceExplorerV2ViewDeleteDialog
          open
          id={id}
          name={name}
          closeMenu={closeDialog}
        />
      )}

      {selectedActionType === "rename" && (
        <ResourceExplorerV2ViewRenameDialog
          open
          id={id}
          name={name}
          closeMenu={closeDialog}
        />
      )}
    </Fragment>
  );
};

const menuItemSx = {
  pl: 1,
  pr: 1.5,
};

const iconSx = {
  minWidth: 28,
};
